<div class="mb-5">
	<h1 class="h3 m-4">{{'utilization.site_fleet_utilization_score' | translate}} <app-help-tooltip [field]="'site_fleet_utilization_score'"></app-help-tooltip></h1>
	<app-score-chart
		*ngIf="data"
		[data]="data"
		[devices]="devices"
		chartType="fleet_utilization_score"
		[daysFilterSelected]="selectedDaysFilter"
		[periodSelected]="selectedPeriod"
		[truckTypeSelected]="selectedTruckType"
		[hideFilters]="hideFilters"
		[totalTrucks]="totalTrucks"
	></app-score-chart>
</div>
